/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationCandidateProfileSettingsUpdatePathParams,
	OrganisationCandidateProfileSettingsUpdateRequest,
	OrganisationCandidateProfileSettingsUpdateResponse,
} from '../types/OrganisationCandidateProfileSettingsUpdate'

/**
 * PUT /organisations/:organisation/candidate-profile-settings
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationCandidateProfileSettingsController.php OrganisationCandidateProfileSettingsController::update
 */
export async function organisationCandidateProfileSettingsUpdate(
	organisation: OrganisationCandidateProfileSettingsUpdatePathParams['organisation'],
	data: OrganisationCandidateProfileSettingsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationCandidateProfileSettingsUpdateResponse>> {
	return axiosInstance.put(`/organisations/${organisation}/candidate-profile-settings`, data, config)
}
